module.exports = __webpack_public_path__ + "img/ciragan_0.6a39ea9c.jpg";